import { TourAllocationOutputWithOutStatus } from './tour-allocation-output-with-out-status.model';


export class TourAllocationSelectByIdOutput implements ITourAllocationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TourAllocationOutputWithOutStatus;

    constructor(data?: ITourAllocationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TourAllocationOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourAllocationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TourAllocationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourAllocationSelectByIdOutput {
    status: number;
    message: string;
    data: TourAllocationOutputWithOutStatus;
}

